import { Controller } from "stimulus"

export default class extends Controller {
  static values = {
    publishableKey: String,
  };

  onPostSuccess(event) {
    const [data] = event.detail;

    if (data.type !== "card") { return; }
    if (!data.hasOwnProperty("stripe_session_id")) { return; }

    const stripe = Stripe(this.publishableKeyValue);

    stripe.redirectToCheckout({ sessionId: data.stripe_session_id });
  }
}
